<!-- <label *ngIf="label" [for]="id" class="global-form-field mb-2">{{ label }}</label>
<select [id]="id" [name]="name" [disabled]="disabled" [(ngModel)]="value" (ngModelChange)="onChange($event)" class="form-select global-form-field"
    [required]="required" #inputModel="ngModel">
    <option *ngFor="let option of options" [value]="option.Value">{{ option.Label }}</option>
</select>
<div *ngIf="inputModel.invalid && inputModel.touched" class="error"><span>This field is required.</span></div> -->


<select [id]="id" [name]="name" [disabled]="disabled" hidden [(ngModel)]="value" (ngModelChange)="onChange($event)" class="form-select global-form-field"
    [required]="required" #inputModel="ngModel">
</select>

<label class="global-form-field mb-2" *ngIf="label" [for]="'wrapper' + id">{{label | translate}} <span class="text-danger fw-bold" *ngIf="required">*</span></label>

<div class="wrapper" [ngClass]="{'disabled':disabled}" #wrapper [attr.id]="'wrapper' + id" [attr.name]="name"  [class.active]="isActive">
    <div class="select-btn" [ngClass]="{'disabled-show':disabled}" (click)="selectBoxClick()">
      <span class="hideme">{{displayLabel || '---'}}</span>
      <i class="fa-solid fa-chevron-down"></i>
    </div>

    <div class="content">
      <div class="search" data-bs-toggle="tooltip" data-bs-placement="top" title="Search Option">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input #searchInput type="search" placeholder="" (input)="onSearchOption($event)" id="slectbox-search" name="slectbox-search">
      </div>
      <ul class="options">
        <li *ngFor="let item of options" (click)="clickFun(item)">{{item.Label}}</li>
        <li *ngIf="!options || options.length <=0">No Data Found.</li>
      </ul>
    </div>

    <span class="hint-text mt-1" *ngIf="isShowOriginValue(value) && showOriginalValue">
      Origin value: <span class="hint-text-strong">{{value}}</span>
    </span>

    <div *ngIf="showRequiredError()" class="error">
        <span>This field is required.</span>
    </div>

  </div>
